import * as React from "react";
const SvgPlay = props => <svg viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 1L15 10L1 19V1Z" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgPlay;